module.exports = __webpack_public_path__ + "static/media/anyone-online-shopping.ddb25d14.jpg";